module.exports = {
	"rows": [
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1334836925000,
					"to": 1334837045000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1334837045000,
					"to": 1334837183000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1 просрочен",
					"from": 1334923578000,
					"to": 1334929209000,
					"color": "#F9C4E1"
				},
				{
					"desc": "Шаг 1",
					"from": 1334837183000,
					"to": 1334923578000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23 просрочен",
					"from": 1334964989000,
					"to": 1458903330000,
					"color": "#F9C4E1"
				},
				{
					"desc": "Шаг 23",
					"from": 1334929209000,
					"to": 1334964989000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1458903330000,
					"to": 1458903772000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1458903772000,
					"to": 1458917411000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1458917411000,
					"to": 1458917422000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1458917422000,
					"to": 1458918928000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1458918928000,
					"to": 1458919504000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1458919504000,
					"to": 1459872409000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1459872409000,
					"to": 1460993069000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1460993069000,
					"to": 1461745330000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1461745330000,
					"to": 1461745347000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23",
					"from": 1461745347000,
					"to": 1461774181000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1461774181000,
					"to": 1461777151000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 23",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 23 просрочен",
					"from": 1470417120000,
					"to": 1475072710000,
					"color": "#F9C4E1"
				},
				{
					"desc": "Шаг 23",
					"from": 1461777151000,
					"to": 1470417120000,
					"color": "#D0E4FD"
				}
			]
		},
		{
			"name": "Шаг 1",
			"link": "#0",
			"values": [
				{
					"desc": "Шаг 1",
					"from": 1483712640000,
					"to": 1499953482327,
					"color": "#F9C4E1"
				},
				{
					"desc": "Шаг 1",
					"from": 1475072710000,
					"to": 1483712640000,
					"color": "#D0E4FD"
				}
			]
		}
	],
	"legendHelp": "Help"
};


//////////////////
// WEBPACK FOOTER
// ./src/data.json
// module id = 204
// module chunks = 1